import { api } from "@/api/client";
import { convertToURLSearchParams } from "@/util";
import { Welder } from "../welders";

export type WeldListFilters = {
  onlyMyWelds: boolean;
  onlyWeldsNotMade: boolean;
  onlyRepairWelds: boolean;
  onlyWeldsReadyForNdt: boolean;
};

export type WelderWeld = {
  weldId: string;
  weldNumber: string;
  jointType: string;
  testPack: string;
  inspectionClass: string;
  madeDate: Date | null;
  drawingId: string;
  process: string;
};

export type WelderRow = {
  weldId: string;
  passId: string;
  weldNumber: string;
  process: string;
  wpsNumber: string;
  filler: string;
  heatNumber: string;
  welder?: Welder;
  made: boolean;
};

export type InspectorWeld = {
  weldId: string;
  weldNumber: string;
  jointType: string;
  testPack: string;
  inspectionClass: string;
  madeDate: Date | null;
  techniques: string;
  drawingId: string;
};

export type InspectorRow = {
  weldId: string;
  weldNumber: string;
  jointType: string;
  drawingId: string;
  technique: string;
  accept?: boolean;
  defect: string;
  attachment?: File;
  comment: string;
};

export function getWelderWelds(datasheetId: string, filters: Partial<WeldListFilters>) {
  const params = convertToURLSearchParams({ datasheetId, ...filters });
  return api.get<WelderWeld[]>(`cds/rbi/welder/welds?${params.toString()}`);
}

export function getWelderRows(weldIds: string[]) {
  return api.post<WelderRow[]>("cds/rbi/welder/processes", weldIds);
}

export function saveWelderRows(processes: WelderRow[]) {
  return api.post("cds/rbi/welder", processes);
}

export function getInspectorWelds(datasheetId: string, filters: Partial<WeldListFilters>) {
  const params = convertToURLSearchParams({ datasheetId, ...filters });
  return api.get<InspectorWeld[]>(`cds/rbi/inspector/welds?${params.toString()}`);
}

export function getInspectorRows(weldIds: string[]) {
  return api.post<InspectorRow[]>("cds/rbi/inspector/inspections", weldIds);
}

export function saveInspectorRows(inspections: InspectorRow[]) {
  return api.post("cds/rbi/inspector", inspections);
}
